/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ap-angular2-fullcalendar/src/calendar/calendar';
const styles_CalendarComponent:any[] = ([] as any[]);
export const RenderType_CalendarComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CalendarComponent,
  data: {}
}
);
export function View_CalendarComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_CalendarComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'angular2-fullcalendar',([] as any[]),(null as any),(null as any),(null as any),View_CalendarComponent_0,RenderType_CalendarComponent)),
    import0.ɵdid(4243456,(null as any),0,import1.CalendarComponent,[import0.ElementRef],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CalendarComponentNgFactory:import0.ComponentFactory<import1.CalendarComponent> = import0.ɵccf('angular2-fullcalendar',import1.CalendarComponent,View_CalendarComponent_Host_0,{options: 'options'},{initialized: 'initialized'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvbm9kZV9tb2R1bGVzL2FwLWFuZ3VsYXIyLWZ1bGxjYWxlbmRhci9zcmMvY2FsZW5kYXIvY2FsZW5kYXIubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9ub2RlX21vZHVsZXMvYXAtYW5ndWxhcjItZnVsbGNhbGVuZGFyL3NyYy9jYWxlbmRhci9jYWxlbmRhci5kLnRzIiwibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9ub2RlX21vZHVsZXMvYXAtYW5ndWxhcjItZnVsbGNhbGVuZGFyL3NyYy9jYWxlbmRhci9jYWxlbmRhci5kLnRzLkNhbGVuZGFyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy92ZXJjZWwvd29ya3BhdGgwL25vZGVfbW9kdWxlcy9hcC1hbmd1bGFyMi1mdWxsY2FsZW5kYXIvc3JjL2NhbGVuZGFyL2NhbGVuZGFyLmQudHMuQ2FsZW5kYXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2PjwvZGl2PiIsIjxhbmd1bGFyMi1mdWxsY2FsZW5kYXI+PC9hbmd1bGFyMi1mdWxsY2FsZW5kYXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O3lCQ0FBOzs7O0lDQUE7Z0JBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/~/ap-angular2-fullcalendar/src/calendar/calendar.ngfactory.ts